export default __webpack_public_path__ + "static/media/icon-forfeit.aaa8d818.svg";